<template>
  <ag-modal-container
    title="Ajouter une référence"
    width="800px"
    @close="back"
  >
    <partNumber-form
      v-model="value"
      level-choice
      @validate="isValid = $event"
    />

    <template v-slot:footer>
      <v-spacer />
      <v-btn
        :loading="loading"
        :disabled="!isValid"
        color="accent"
        class="ml-5"
        @click="create"
        v-text="'Ajouter'"
      />
    </template>
  </ag-modal-container>
</template>

<script>
import { mapActions } from 'vuex'
import Repositories from 'src/repositories'

import AgModalContainer from 'src/components/common/AgModalContainer'
import PartNumberForm from '../components/PartNumberForm'

export default {
  name: 'PartNumberCreateContainer',
  components: {
    AgModalContainer,
    PartNumberForm,
  },
  data: () => ({
    isValid: false,
    loading: false,
    value: {
      name: '',
      clone: false,
      partType: null,
      partNumberToDuplicate: null,
    },
  }),
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    back () {
      this.$router.back()
    },
    async create () {
      this.loading = true
      try {
        await Repositories.partNumber.post(this.value)
        this.showSuccessNotification(`La référence ${this.value.name} a bien été créé`)
        this.back()
      }
      catch (error) {
        this.showErrorNotification(Repositories.parseErrorMessage(error))
      }
      finally {
        this.loading = false
      }
    },
  },
}
</script>
